<template>
    <div class="bordas legenda-content"> 
        <button type="button" class="btn btn-success btn-sm btn-legenda font-weight-bold"> 
            Livres: {{livres}}
        </button>
                
        <button type="button" class="btn btn-info btn-sm btn-legenda font-weight-bold"> 
            Cedidos: {{cedidos}}
        </button>
    </div>   
</template>

<script>
export default {
    computed: {
        livres () {
            return this.$store.getters['tipoleito/getQuantitativoLeitosLivres']
        },
        cedidos () {
            return this.$store.getters['tipoleito/getQuantitativoLeitosCedidos']
        }
    },
    methods: {
     
    }
}
</script>

<style>
    .legenda-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }

    .btn-legenda {
        margin: 6px 6px 6px 6px;
        min-width: 125px;
    }

    @media (min-width: 1154px) {
        .legenda-content {
            flex-direction: column;
        }

        .btn-legenda {
            margin: 0 0 10px 0;
        }
    }

</style>

